import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-form-configuration-tab-select',
    templateUrl: './form-configuration-tab-select.component.html',
    styleUrls: ['./form-configuration-tab-select.component.scss'],
    standalone: false
})
export class FormConfigurationTabSelectComponent implements OnInit {

  
  options:BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  tabs = new UntypedFormControl(null, [
    Validators.required
  ]);
  
  constructor(@Inject(NZ_MODAL_DATA) public data, public dialogRef:NzModalRef<any>) { }

  ngOnInit(): void {
    this.options.next(this.data);
  }

  ngAfterContentInit(): void {
    
  }

  salvar(){
    
    this.dialogRef.close(this.tabs.value)
  }
}
